var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifierMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H12H14H16C16.5523 12 17 12.4477 17 13C17 13.5523 16.5523 14 16 14H14H12H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C8.02944 4 4 8.02944 4 13C4 17.9706 8.02944 22 13 22C15.125 22 17.078 21.2635 18.6177 20.0319L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L20.0319 18.6177C21.2635 17.078 22 15.125 22 13C22 8.02944 17.9706 4 13 4ZM13 6C9.13401 6 6 9.13401 6 13C6 16.866 9.13401 20 13 20C16.866 20 20 16.866 20 13C20 9.13401 16.866 6 13 6Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierMinus);
export default __webpack_public_path__ + "static/media/magnifier_minus.f3396938e8e5a16ced6081273be5126c.svg";
export { ForwardRef as ReactComponent };